import {
  Flex, FormControl, FormLabel, Input,
  InputGroup, InputRightElement
} from '@chakra-ui/react'
import { useState } from 'react'
import { MdClose } from 'react-icons/md'
import { ButtonCmp } from '../../../../../../components/ButtonCmp'
import { InputCmp } from '../../../../../../components/InputCmp'
import { ModalBase } from '../../../../../../components/ModalBase'
import { iPostDemografiaPEC } from '../../../../../../interfaces'

interface iModalProps {
  isOpen: boolean
  onClose: () => void
  onCreate: (form: iPostDemografiaPEC) => void
}

export const ModalCreateDemografia: React.FC<iModalProps> = ({ isOpen, onClose, onCreate }) => {
  const [Demografias, setDemografias] = useState<string[]>(['Grupo'])
  const [Nome, setNome] = useState('')
  function UpdateDemografiasArray(index: number, Texto: string): void {
    const array = [...Demografias]
    array[index] = Texto
    setDemografias(array)
  }

  function DeleteItemArray(index: number): void {
    const dems: string[] = []
    Demografias.forEach((e, i) => {
      if (index !== i) { dems.push(e) }
    })
    setDemografias(dems)
  }

  return (
        <ModalBase
            Titulo="Nova demografia (grupo para análise)"
            Subtitulo="A análise só poderá ser feita com dados a partir da data que a demografia foi inserida."
            onClose={onClose}
            isOpen={isOpen}
            Width='60rem'
        >
            <Flex flexDirection={'column'} padding={'1rem'} borderBottom={'1px solid var(--c4)'}>
                <FormControl>
                    <InputCmp
                        placeholder='Digite o nome'
                        label='Nome da demografia'
                        width={'18rem'}
                        value={Nome}
                        OnChange={setNome}
                    />
                </FormControl>

                <FormControl mt={'.75rem'}>
                    <FormLabel pos={'relative'} mr={'0'} color={'var(--Gray1)'} fontSize={'14px'} mb={'.25rem'} wordBreak={'keep-all'}>Grupos</FormLabel>
                    <Flex display={'grid'} gap={'1rem 1rem'}>
                        {
                            Demografias.map((e, i) => {
                              return (
                                    <InputGroup key={i}>
                                        {
                                            (i > 0) && (
                                                <InputRightElement
                                                    h={'1.925rem'}
                                                    children={<MdClose cursor={'pointer'}
                                                    onClick={() => DeleteItemArray(i)}
                                                    color='var(--Red)' />}
                                                />
                                            )
                                        }
                                        <Input
                                            placeholder={`Grupo ${i !== 0 ? i : ''}`}
                                            borderColor={'var(--Gray4)'}
                                            height={'1.925rem'}
                                            fontSize={'14px'}
                                            borderRadius='4px'
                                            value={e}
                                            onChange={(e) => UpdateDemografiasArray(i, e.target.value)}
                                        />
                                    </InputGroup>
                              )
                            })
                        }

                    </Flex>
                </FormControl>

                <Flex marginTop={'1rem'}>
                    <ButtonCmp
                        VarColor='Green2'
                        onClick={() => setDemografias(oldArray => [...oldArray, ''])}
                    >Adicionar</ButtonCmp>
                </Flex>
            </Flex>
            <Flex justifyContent={'end'} padding={'1rem'}>
                <ButtonCmp
                    VarColor='Green2'
                    onClick={() => onCreate({
                      demografias: Demografias,
                      pergunta: Nome
                    })}
                >Salvar</ButtonCmp>
            </Flex>
        </ModalBase>
  )
}
